module.exports = __webpack_public_path__ + "static/media/safes_hero_ss.ee418a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/enhanced-brand/safes_hero_ss.png
// module id = 1199
// module chunks = 0